import { APP_PERMISSIONS_NAME } from '../../constants';
import type {
  AppPermissionDetails,
  AppRolePermissionMap,
  AppPermission,
  AppRolePermissionItem,
} from '../../types';
import { extractCategoryAndNameAndAction } from '../extract-permission';

export function mapAppRolePermission(
  appPermissions: AppPermission[],
  appRolePermissionItems: AppRolePermissionItem[],
  permissionDisplayOrder: string[],
) {
  const mapper: AppRolePermissionMap = {};

  for (const appPermission of appPermissions) {
    const { action, category, name } = extractCategoryAndNameAndAction(appPermission.id);

    mapper[category] = mapper?.[category] ?? {};
    mapper[category][name] = mapper?.[category]?.[name] ?? {};
    mapper[category][name][action] = false;
  }

  for (const appRolePermissionItem of appRolePermissionItems) {
    const { action, category, name } = extractCategoryAndNameAndAction(appRolePermissionItem.id);

    mapper[category][name][action] = true;
  }

  const appPermissionDetails: AppPermissionDetails[] = [];

  for (const [key, value] of Object.entries(mapper)) {
    const splittedKey = key.split('-');
    const groupKey = splittedKey.length > 1 ? splittedKey?.[0] : null;

    const header = {
      id: key,
      appPermission: APP_PERMISSIONS_NAME[key],
      type: 'header' as const,
    };

    if (groupKey) {
      const group = {
        id: groupKey,
        appPermission: APP_PERMISSIONS_NAME[groupKey],
        type: 'group' as const,
      };
      appPermissionDetails.push(group);
    }

    const rows: AppPermissionDetails[] = Object.entries(value).map(([name, action]) => ({
      id: `${key}.${name}`,
      header: key,
      appPermission: APP_PERMISSIONS_NAME[`${key}.${name}`],
      view: action['view'],
      update: action['update'],
      create: action['create'],
      status: action['status'],
      delete: action['delete'],
      type: 'feature',
    }));
    appPermissionDetails.push(header, ...rows);
  }

  appPermissionDetails.sort((a, b) => {
    const aIndex = permissionDisplayOrder.indexOf(a.id);
    const bIndex = permissionDisplayOrder.indexOf(b.id);
    return aIndex - bIndex;
  });

  return appPermissionDetails;
}
